module.exports = __webpack_public_path__ + "static/media/viewAuditTrailGuide1_Jap.f96a2c73.png";